/** Attachments one message may carry, whatever their kind. */
export const MAX_ATTACHMENTS = 5

/**
 * The combined length of every data URL one chat request may carry. The chat routes refuse a larger
 * body (`attachments_too_large`), so the console refuses before sending rather than after the upload.
 * The one place this number lives on the console side.
 */
export const MAX_ATTACHMENT_DATA_URL_CHARS = 5_000_000

/** The chat routes' field limits: a PDF's name, and an attached Library file's title. */
export const MAX_DOCUMENT_NAME_CHARS = 255
export const MAX_ATTACHED_FILE_TITLE_CHARS = 300

/** A PDF is sent as is, so its raw size is capped. */
export const MAX_PDF_BYTES = 3.5 * 1024 * 1024

/** A data file goes to the Library through the upload service, whose ceiling is 1 GiB. */
export const MAX_DATA_FILE_BYTES = 1024 * 1024 * 1024

/** Pictures are scaled so their long edge is at most this, then encoded as JPEG. */
export const IMAGE_MAX_EDGE = 1568
export const IMAGE_JPEG_QUALITY = 0.85

/** Who is attaching: a guest, or the signed-in user's role. */
export type AttachRole = 'guest' | 'viewer' | 'publisher' | 'admin'
